export const ROW_HIGHLIGHT_ANIMATION = {
	steps: [
		{ backgroundColor: 'white' },
		{ backgroundColor: '#E7FEEA' },
		{ backgroundColor: 'white' },
	],
	options: { duration: 3000, iterations: 1 },
};
